import clsx from "clsx";
import "./InfoSectionCard.scss";
import { Col } from "@/components";

type InfoSectionCardProps = {
  title?: string;
  children?: React.ReactNode;
};

export const InfoSectionCard = ({ title, children }: InfoSectionCardProps) => {
  return (
    <label className={clsx("shadow  br-x4 ui-radio-card-container")}>
      <Col style={{ width: "100%" }}>
        <Col py={"x32"} px={"x24"}>
          <div className="fw-semibold text-slate-20 fs-4">{title}</div>
        </Col>
        <Col
          style={{
            height: 1,
            backgroundColor: "#C5C7C9",
            width: "100%",
          }}
        />
        <Col p={"x24"}>{children}</Col>
      </Col>
    </label>
  );
};
